import type { Game, GameResult, ID, StatEvent, StatTypeId } from './types'

/** Result is always derived from the scores, never stored. */
export function gameResult(game: Pick<Game, 'ourScore' | 'theirScore'>): GameResult | null {
  const { ourScore, theirScore } = game
  if (ourScore == null || theirScore == null) return null
  if (ourScore > theirScore) return 'W'
  if (ourScore < theirScore) return 'L'
  return 'D'
}

export function liveEvents(events: StatEvent[]): StatEvent[] {
  return events.filter((e) => !e.deleted)
}

/** Key for the per-player-per-stat tally map. */
export function tallyKey(playerId: ID, statType: StatTypeId): string {
  return playerId + ' ' + statType
}

/**
 * Running counts for the live grid. Counts the whole game across all periods --
 * the buttons show a game total, not a period total.
 */
export function tally(events: StatEvent[]): Map<string, number> {
  const counts = new Map<string, number>()
  for (const e of events) {
    if (e.deleted) continue
    const key = tallyKey(e.playerId, e.statType)
    counts.set(key, (counts.get(key) ?? 0) + 1)
  }
  return counts
}

export function teamTotal(events: StatEvent[], statType: StatTypeId): number {
  let n = 0
  for (const e of events) if (!e.deleted && e.statType === statType) n++
  return n
}

/** Most recently recorded live event -- the one UNDO reverts. */
export function lastLiveEvent(events: StatEvent[]): StatEvent | null {
  let best: StatEvent | null = null
  for (const e of events) {
    if (e.deleted) continue
    if (!best || e.at > best.at) best = e
  }
  return best
}
